import { render, staticRenderFns } from "./batch-rename.vue?vue&type=template&id=a845b5c6&"
import script from "./batch-rename.vue?vue&type=script&lang=ts&"
export * from "./batch-rename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports